/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/* jshint laxbreak: true */
angular.module('bulbApp.assetLibraryModule').controller('AssetContainerController', [
  '$',
  '$interval',
  '$modalStack',
  '$q',
  '$scope',
  '$timeout',
  '$translate',
  '$window',
  'ImageCropperDialogService',
  'AeroDialogService',
  'AssetUploadEventService',
  'BulbAssetLibraryGoogleDriveService',
  'BulbAssetLibraryGooglePhotoService',
  'BulbAssetLibraryUnsplashService',
  'BulbAssetLibraryUploadService',
  'BulbAssetLibraryService',
  'BulbAssetLibraryOneDriveService',
  'BulbAuthService',
  'BulbBlockViewSwitcherService',
  'BulbBrowserService',
  'BulbBusyCoverService',
  'BulbErrorService',
  'BulbModalService',
  'RecordEventService',
  'ASSET_LIBRARY',
  'CONFIG',
  'DRAG',
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  AssetContainerController]);

function AssetContainerController(
  $,
  $interval,
  $modalStack,
  $q,
  $scope,
  $timeout,
  $translate,
  $window,
  ImageCropperDialogService,
  AeroDialogService,
  AssetUploadEventService,
  BulbAssetLibraryGoogleDriveService,
  BulbAssetLibraryGooglePhotoService,
  BulbAssetLibraryUnsplashService,
  BulbAssetLibraryUploadService,
  BulbAssetLibraryService,
  BulbAssetLibraryOneDriveService,
  BulbAuthService,
  BulbBlockViewSwitcherService,
  BulbBrowserService,
  BulbBusyCoverService,
  BulbErrorService,
  BulbModalService,
  RecordEventService,
  ASSET_LIBRARY,
  CONFIG,
  DRAG,
) {
  const that = this;

  // Adding the controller onto the window object, so we could potentially reference it in our Angular Framework.
  // In this use case, we need access to the callback functions when an audio asset is uploaded, so 'uploadFileAdd'
  // etc...
  // We could upgrade this controller to a pure Angular component, which would be better, however the time to refactor
  // This controller would outweigh any cost ( at the moment -- we are going to have to do this at some point ).
  // eslint-disable-next-line no-param-reassign
  $window.bulbVars.AssetContainerController = this;

  this.currentUserPrefs = BulbAuthService.currentUser.prefs;
  this.isMobile = BulbBrowserService.isMobile();

  this.isUnsplashAvailable = BulbAuthService.currentUser.features.UnsplashRestrictionFeature.value !== 'DISABLED';

  this.breadcrumb = [];
  this.entries = null;
  this.totalResults = 0;
  this.itemsPerPage = that.currentUserPrefs.assetLibraryEntriesPerPage;

  $scope.viewSwitcherService = BulbBlockViewSwitcherService;
  $scope.assetLibraryService = BulbAssetLibraryService;
  $scope.currentUser = BulbAuthService.currentUser;

  this.infiniteScrollWindowEnabled = true;

  // list / tile view info type
  this.infoType = 'asset_library';

  this.currentFolderId = null;
  this.searchEnabled = false;
  this.searchComplete = false;
  this.query = null;

  this.condition = {
    assetLibrarySortKey: 'NAME',
    assetLibrarySortOrderAsc: true,
    typeFilter: {
      IMAGE: false,
      VIDEO: false,
      ATTACHED_FILE: false,
      AUDIO: false,
    },
  };

  const $body = $('body');

  /**
   * Function that checks to see if the target entry asset from within the asset library is being used within the
   * Archive Collection.
   *
   * @param collections The collections array that is a property of the target entry's usage object. The collections
   *             Array will house all the collections that the asset has a reference to (is used by).
   * @return {boolean} True if the asset is used within the archive collection array.
   */
  this.hasReferenceToTheArchiveCollection = function hasReferenceToTheArchiveCollection(collections) {
    const index = collections?.indexOf((collection) => collection.type === 'ARCHIVE_COMPOSITE');
    return index !== -1;
  };

  {
    const { prefs } = BulbAuthService.currentUser;
    if (prefs.assetLibrarySortKey) {
      $.extend(this.condition, prefs);
    }
  }

  // ==============================
  // drag/drop
  // ==============================
  this.itemDragOptions = {
    get: function get() {
      return BulbBlockViewSwitcherService.isTile(that.infoType) ? that.itemDragOptions.tile
        : that.itemDragOptions.list;
    },

    list: {
      revert: 'invalid',
      containment: '#bulb-asset-library-container',
      opacity: 0.5,
      stop: function stop(event) {
        $(event.currentTarget).removeClass('ui-draggable-dragging');
      },
    },

    tile: {
      revert: 'invalid',
      containment: '#bulb-content',
      opacity: 0.5,
      stop: function stop(event) {
        $(event.currentTarget).removeClass('ui-draggable-dragging');
      },
    },
  };

  this.itemDropOptions = {
    list: {
      hoverClass: 'bulb-asset-droppable',
    },

    tile: {
      hoverClass: 'bulb-asset-droppable',
    },
  };

  let touchTimer = null;
  let draggingItem = null;
  let touchStartScrollTop;
  let observingDragStartDesktop = false; // true on mousedown. If followed by mousemove, drag is started
  let lastMouseDownEvent = null; // Event for last mousedown on desktop.

  // Starts the drag on the element.
  const dragHandler = function dragHandler(event) {
    if (event.type === 'touchstart') {
      // touch
      if (touchStartScrollTop !== $(document).scrollTop()) {
        // for iOS
        return;
      }
    }

    if (touchTimer) {
      clearTimeout(touchTimer);
      touchTimer = null;
    }

    if (draggingItem) {
      return;
    }

    if (BulbModalService.getTopModalElement()) {
      return;
    }

    const tmp = $(event.currentTarget);
    if (tmp.is('.ui-draggable')) {
      // already initialized
      draggingItem = tmp.draggable('destroy'); // Setting this tells other functions we're actively dragging.
    }

    draggingItem = tmp.draggable(that.itemDragOptions.get());
    draggingItem.addClass('ui-draggable-dragging');
    draggingItem.trigger(event);
  };

  // Handler for desktop mouse down in order to handle the potential start of a drag.
  this.onItemMouseDown = function onItemMouseDown(event) {
    if (draggingItem) {
      return;
    }
    observingDragStartDesktop = true;
    lastMouseDownEvent = event;
  };

  this.onItemTouchStart = function onItemTouchStart(event) {
    if (draggingItem) {
      return;
    }
    touchStartScrollTop = $(document).scrollTop();

    touchTimer = setTimeout(() => {
      if (touchTimer) {
        dragHandler(event);
      }
    }, DRAG.TOUCH_DELAY);
  };

  this.initDraggable = function initDraggable() {
    $timeout(() => {
      const tile = BulbBlockViewSwitcherService.isTile(that.infoType);
      if (tile) {
        $('#bulb-assetlibrary-tile').children().on('mousedown', that.onItemMouseDown).on(
          'touchstart',
          that.onItemTouchStart,
        );
      } else {
        $('#bulb-assetlibrary-list').children().on('mousedown', that.onItemMouseDown).on(
          'touchstart',
          that.onItemTouchStart,
        );
      }
    }, 200);
  };

  // Someone comment why this has a delay if you ever figure out why.
  this.finishDragging = function finishDragging(interval) {
    observingDragStartDesktop = false;

    if (touchTimer) {
      clearTimeout(touchTimer);
      touchTimer = null;
    }

    if (draggingItem) {
      $timeout(() => {
        draggingItem.removeClass('ui-draggable-dragging');
        draggingItem.draggable('disable');
        draggingItem = null;
      }, interval);
    }
  };

  if (!this.readOnly) {
    $body.on('mouseup touchend', () => {
      that.finishDragging(DRAG.END_EVENT_DRAG_KILL_WAIT);
    });

    if (!BulbBrowserService.isMobile()) {
      $body.on('mousemove', (moveEvent) => {
        if (observingDragStartDesktop) { // CASE, user pressed the mouse down.
          if (lastMouseDownEvent.pageX !== moveEvent.pageX || lastMouseDownEvent.pageY !== moveEvent.pageY) {
            observingDragStartDesktop = false; // Because we're starting the drag officially.
            dragHandler(lastMouseDownEvent); // Starts the drag on desktop
          }
        }
      });
    }
  }

  $scope.onEntryDrop = function onEntryDrop(event, ui, target) {
    const droppedEntry = ui.draggable.scope().entry;
    const deferred = $q.defer();
    BulbBusyCoverService.showBusyDuring(deferred.promise);
    ui.draggable.fadeOut(500, () => {
      BulbAssetLibraryService.api.moveEntry(droppedEntry.id, target.id).then(() => {
        that.getEntriesAndUpdateList();
        deferred.resolve();
      }, deferred.reject);
    });
  };

  // ==============================
  // misc
  // ==============================
  const getEntryElementById = function getEntryElementById(id) {
    return $(`#asset-${id}`);
  };

  const getEntryElement = function getEntryElement(entry) {
    return getEntryElementById(entry.id);
  };

  this.updateList = function updateList(res) {
    that.entries = res.entries;

    that.breadcrumb = res.breadcrumb;

    // add root folder
    $translate('assetlibrary_breadcrumb_root').then(
      (rootLabel) => {
        that.breadcrumb.unshift({
          id: null,
          name: rootLabel,
        });
      },
    );

    that.totalResults = res.totalResults;

    if (!that.readOnly) {
      // add mouse down and touch start handler
      that.initDraggable();
    }

    $scope.$emit('listUpdated');
  };

  this.redirectTo = function redirectTo(url, $event) {
    $window.open(`${url}?utm_source=${CONFIG.unsplash.client.application.name}&utm_medium=referral`, '_blank');
    $event.stopPropagation();
  };

  this.getEntries = function getEntries(completeHandler, pageNumber) {
    const tmpCondition = angular.merge({}, that.condition);
    const { typeFilter } = tmpCondition;
    if (!typeFilter.IMAGE && !typeFilter.VIDEO && !typeFilter.ATTACHED_FILE && !typeFilter.AUDIO) {
      tmpCondition.typeFilter = {
        IMAGE: true,
        VIDEO: true,
        ATTACHED_FILE: true,
        AUDIO: true,
      };
    }

    tmpCondition.currentPage = (pageNumber && pageNumber > 0) ? (pageNumber - 1) : 0;
    tmpCondition.itemsPerPage = (that.itemsPerPage && that.itemsPerPage > 0) ? that.itemsPerPage : 0;

    let promise;
    if (that.searchEnabled && !that.isSearchQueryEmpty()) {
      promise = BulbAssetLibraryService.api.search(that.query, tmpCondition).finally(() => {
        that.lastQuery = that.query;
        that.searchComplete = that.searchEnabled;
      });
    } else {
      promise = BulbAssetLibraryService.api.getEntries(that.currentFolderId, tmpCondition);
    }

    promise.then(completeHandler);
  };

  this.getEntriesAndUpdateList = function getEntriesAndUpdateList(pageNumber) {
    that.getEntries((res) => {
      that.page = pageNumber;
      that.updateList(res);
    }, pageNumber);
  };

  this.search = function search() {
    this.searchEnabled = true;
    this.getEntriesAndUpdateList();
  };

  this.cancelSearch = function cancelSearch() {
    this.query = null;
    this.lastQuery = null;
    this.searchEnabled = false;
    this.searchComplete = false;
    this.entries = null;
    this.totalResults = 0;
    this.getEntriesAndUpdateList();
  };

  this.isSearchQueryEmpty = function isSearchQueryEmpty() {
    return (this.query === null || this.query.length === 0 || this.query.trim() === '');
  };

  this.queryOnKeyDown = function queryOnKeyDown(event) {
    if (event.keyCode === 13) {
      this.query = event.currentTarget.value;
      this.search();
    }
  };

  this.changeSort = function changeSort(key, $event) {
    if (this.condition.assetLibrarySortKey === key) {
      this.condition.assetLibrarySortOrderAsc = !this.condition.assetLibrarySortOrderAsc;
    } else {
      this.condition.assetLibrarySortKey = key;
      this.condition.assetLibrarySortOrderAsc = true;
    }

    setTimeout(() => {
      if (BulbAuthService.currentUser.isAuthenticated()) {
        // eslint-disable-next-line no-param-reassign
        BulbAuthService.currentUser.prefs.assetLibrarySortKey = that.condition.assetLibrarySortKey;
        // eslint-disable-next-line no-param-reassign
        BulbAuthService.currentUser.prefs.assetLibrarySortOrderAsc = that.condition.assetLibrarySortOrderAsc;
        BulbAssetLibraryService.api.updateAccountPrefs();
      }
    }, 1);

    this.getEntriesAndUpdateList();
    $($event.currentTarget).focus();
  };

  this.showFolder = function showFolder(folderId) {
    this.currentFolderId = folderId;
    this.getEntriesAndUpdateList();
  };

  this.switchFilter = function switchFilter(type) {
    this.condition.typeFilter[type] = !this.condition.typeFilter[type];
    this.getEntriesAndUpdateList();
  };

  this.targetEntry = null;
  this.targetEntryIdx = null;
  this.refreshTargetEntry = function refreshTargetEntry(entry, idx) {
    const focusedStyleClass = 'bulb-assetlibrary-focused-entry';

    if (that.targetEntry) {
      getEntryElement(that.targetEntry).removeClass(focusedStyleClass);
    }

    that.targetEntry = entry;
    that.targetEntryIdx = idx;

    if (that.targetEntry.id) {
      getEntryElement(that.targetEntry).addClass(focusedStyleClass);
    }
  };

  this.showDetailModal = function showDetailModal(event, entry, idx) {
    if (event) {
      event.stopPropagation();
    }
    getEntryElement(entry).blur();
    that.refreshTargetEntry(entry, idx);
    if (event) {
      // eslint-disable-next-line no-param-reassign
      entry.focusAfterClosed = event.currentTarget;
      BulbAssetLibraryService.dialog.showDetailModal(that, entry);
    }
  };

  this.updateTargetEntry = function updateTargetEntry() {
    switch (this.targetEntry.type) {
      case 'FOLDER':
        if (this.targetEntry.id) {
          // update
          BulbAssetLibraryService.api.updateFolder(this.targetEntry).then(this.getEntriesAndUpdateList);
        } else {
          // create
          BulbAssetLibraryService.api.createFolder(this.targetEntry).then(this.getEntriesAndUpdateList);
        }
        break;

      case 'IMAGE':
        BulbAssetLibraryService.api.updateImage(this.targetEntry).then(this.getEntriesAndUpdateList);
        break;

      case 'VIDEO':
        BulbAssetLibraryService.api.updateVideo(this.targetEntry).then(this.getEntriesAndUpdateList);
        break;

      case 'AUDIO':
        BulbAssetLibraryService.api.updateAudio(this.targetEntry).then(this.getEntriesAndUpdateList);
        break;

      case 'ATTACHED_FILE':
        BulbAssetLibraryService.api.updateAttachedFile(this.targetEntry).then(this.getEntriesAndUpdateList);
        break;

      default:
        break;
    }
  };

  // ==============================
  // click entry
  // ==============================
  let clickTimer = null;
  const dblClickMaxIntervalMs = 500;

  this.onClick = function onClick(entry, idx, $event) {
    if (draggingItem) {
      return;
    }

    if (clickTimer) {
      clearTimeout(clickTimer);
    }
    const clickHandler = function clickHandler() {
      that.finishDragging(1000);
      switch (entry.type) {
        case 'FOLDER':
          that.searchEnabled = false;
          that.query = null;
          that.lastQuery = null;
          that.showFolder(entry.id);
          break;

        default:
          that.showDetailModal($event, entry, idx);
          break;
      }
    };

    if (BulbBrowserService.isMobile()) {
      clickHandler();
    } else {
      clickTimer = setTimeout(clickHandler, dblClickMaxIntervalMs);
    }
  };

  this.onDblclick = function onDblclick(entry, idx, $event) {
    if (BulbBrowserService.isMobile()) {
      return;
    }

    if (clickTimer) {
      clearTimeout(clickTimer);
    }
    that.showDetailModal($event, entry, idx);
  };

  this.isFirstEntry = function isFirstEntry() {
    return this.targetEntryIdx === 0;
  };

  this.isLastEntry = function isLastEntry() {
    return this.targetEntryIdx === this.entries.length - 1;
  };

  this.getTargetEntryDetail = function getTargetEntryDetail(idx) {
    BulbBusyCoverService.showBusyDuring(
      BulbAssetLibraryService.api.getEntry(this.entries[idx].id).then((response) => {
        // get usage etc.
        that.refreshTargetEntry(response.entry, idx);
      }),
    );
  };

  this.showPrevEntry = function showPrevEntry() {
    if (this.targetEntryIdx === 0) {
      return;
    }
    const idx = this.targetEntryIdx - 1;
    this.getTargetEntryDetail(idx);
  };

  this.showNextEntry = function showNextEntry() {
    if (this.targetEntryIdx === this.entries.length - 1) {
      return;
    }
    const idx = this.targetEntryIdx + 1;
    this.getTargetEntryDetail(idx);
  };

  $scope.$watch(() => (that.targetEntry ? that.targetEntry.id : null), () => {
    BulbAssetLibraryService.dialog.setDefaultFocusInModal();
  });

  this.consumeEvent = function consumeEvent($event) {
    $event.stopPropagation();
    if ($event.currentTarget.tagName === 'INPUT') {
      // prevent submit
      switch ($event.keyCode) {
        case 13: // enter
          $event.preventDefault();
          break;

        case 27: // escape
          BulbAssetLibraryService.dialog.closeCurrentModal();
          break;

        default:
          break;
      }
    }
  };

  // ==============================
  // manipulate entry
  // ==============================
  this.showDeleteEntryDialog = function showDeleteEntryDialog(event, entry) {
    BulbAssetLibraryService.dialog.showDeleteEntryDialog(event, entry, that.getEntriesAndUpdateList);
  };

  this.showCreateFolderDialog = function showCreateFolderDialog($event) {
    const entry = {
      name: '',
      folderId: that.currentFolderId,
      type: 'FOLDER',
      focusAfterClosed: $event.currentTarget,
    };
    this.showDetailModal($event, entry, null);
  };

  // ==============================
  // Google Drive
  // ==============================
  this.onSelectedHandler = function onSelectedHandler(oauthToken, id, mimeType, photoParentId) {
    BulbBusyCoverService.showBusyDuring(
      BulbAssetLibraryService.api.importFromGoogleDrive(
        oauthToken,
        that.currentFolderId,
        id,
        mimeType,
        photoParentId,
      ).then(() => {
        that.getEntriesAndUpdateList();
        // update storage info
        BulbAuthService.fetchCurrentUser();
      }),
    );
  };

  /**
   * Returns true if the entry mimeType is for Google Docs, sheets or slides.
   * @param mimeType for the asset
   * @returns {boolean} if the entry is for any google asset
   */
  this.isGoogleAsset = function isGoogleAsset(mimeType) {
    if (!that.targetEntry) {
      return false;
    }

    if (mimeType) {
      return mimeType.startsWith('application/vnd.google-apps');
    }
    return that.targetEntry.mimeType.startsWith('application/vnd.google-apps');
  };

  // ==============================
  // Google Photo
  // ==============================
  this.googlePhotoSelectHandler = function googlePhotoSelectHandler(oauthToken, mediaItemsId) {
    angular.forEach(mediaItemsId, (mediaId) => {
      BulbBusyCoverService.showBusyDuring(
        BulbAssetLibraryService.api.importFromGooglePhoto(
          oauthToken,
          that.currentFolderId,
          mediaId,
        ).then(
          () => {
            that.getEntriesAndUpdateList();
            // update storage info
            BulbAuthService.fetchCurrentUser();
          },
        ),
      );
    });
  };

  this.openGooglePickerForVideos = function openGooglePickerForVideos() {
    RecordEventService.recordEvent('google_photos_video', 'asset_library');
    BulbAssetLibraryService.dialog.dismissAllModals();
    BulbAssetLibraryGooglePhotoService.initializeGooglePhotoPicker(that.googlePhotoSelectHandler, true, true);
  };

  this.openImageTypePicker = function openImageTypePicker() {
    BulbAssetLibraryGoogleDriveService.openImageTypePicker(that.onSelectedHandler);
  };

  this.openVideoTypePicker = function openVideoTypePicker() {
    BulbAssetLibraryGoogleDriveService.openVideoTypePicker(that.onSelectedHandler);
  };

  // ==============================
  // Unsplash Photo
  // ==============================
  // Modal option to create Unsplash photos picker

  this.unsplashPhotoSelectionHandler = function unsplashPhotoSelectionHandler(photoId) {
    BulbBusyCoverService.showBusyDuring(
      BulbAssetLibraryUnsplashService.importFromUnsplash(photoId, that.currentFolderId).then(
        () => {
          that.getEntriesAndUpdateList();
          // update storage info
          BulbAuthService.fetchCurrentUser();
          BulbAssetLibraryService.dialog.closeCurrentModal();
        },
      ),
    );
  };

  // ==============================
  // crop
  // ==============================
  this.showImageCropModal = function showImageCropModal() {
    BulbAssetLibraryService.dialog.image.showCropDialog(that.targetEntry, (response) => {
      if (response) {
        BulbAssetLibraryService.dialog.closeCurrentModal();
        const uploadAsset = {
          x: response.croppedData.x,
          y: response.croppedData.y,
          width: response.croppedData.width,
          height: response.croppedData.height,
        };
        that.targetEntry.cropRect = uploadAsset;
        $timeout(() => {
          BulbBusyCoverService.showBusyDuring(
            BulbAssetLibraryService.api.crop(that.targetEntry).then((res) => {
              const latestEntry = res.entry;
              for (let i = 0; i < that.entries.length; i += 1) {
                const e = that.entries[i];
                if (e && e.id === latestEntry.id) {
                  that.entries[i] = angular.merge(e, latestEntry);
                  that.targetEntry = that.entries[i];
                  break;
                }
              }
            }),
          );
        }, 1);
      }
    });
  };

  // ==============================
  // validation
  // ==============================
  this.validation = {
    getOptions: function getOptions() {
      return {
        assetLibraryEntryId: that.targetEntry.id,
        folderId: that.targetEntry.folderId,
      };
    },
  };

  // ==============================
  // upload
  // ==============================
  {
    const checkUploadingStatusInterval = 2000; // ms

    // check uploading & server processing status
    const uploadingStatusChecker = $interval(() => {
      let needChecking = false;
      if (that.entries) {
        for (let i = 0; i < that.entries.length; i += 1) {
          const e = that.entries[i];
          if (e.status && e.status !== 'COMPLETE' && e.status !== 'ERROR') {
            needChecking = true;
          }
        }

        if (needChecking) {
          that.getEntries((res) => {
            const newEntries = {}; let i; let
              e;
            for (i = 0; i < res.entries.length; i += 1) {
              e = res.entries[i];
              newEntries[e.id] = e;
            }

            let changed = false;
            for (i = 0; i < that.entries.length; i += 1) {
              e = that.entries[i];
              const newStatus = newEntries[e.id].status;

              if (!e) {
                // There was an error in the past where an entry was undefined.
                // If this message hasn't led to a fix, we should remove this.
                BulbErrorService.captureErrorMessage(`uploadingStatusChecker: item in that.entries is undefined.
                  i: ${i},
                  that.entries.length: ${that.entries.length}`);
                return;
              }

              if (e && e.status && e.status !== 'COMPLETE' && e.status !== newStatus
                  && (newStatus === 'COMPLETE' || newStatus === 'ERROR')) {
                that.entries[i] = newEntries[e.id];

                changed = true;

                // update targetEntry
                if (that.targetEntry && that.targetEntry.id === e.id) {
                  that.targetEntry = angular.merge(that.targetEntry, newEntries[e.id]);
                }
              }
            }

            if (changed) {
              BulbAuthService.fetchCurrentUser();
              that.initDraggable();
            }
          });
        }
      }
    }, checkUploadingStatusInterval);

    $scope.$on('$destroy', () => {
      $interval.cancel(uploadingStatusChecker);
    });
  }

  this.uploadOptions = {
    // image upload options
    createImageUploadOptions: function createImageUploadOptions(deleteOnEnd) {
      return BulbAssetLibraryUploadService.createImageUploadOptions(
        () => that.currentFolderId,
        that,
        'uploadFileAdd',
        null,
        'uploadFileProgress',
        'uploadFileDone',
        deleteOnEnd,
      );
    },

    // video upload options
    createVideoUploadOptions: function createVideoUploadOptions(deleteOnEnd) {
      return BulbAssetLibraryUploadService.createVideoUploadOptions(
        () => that.currentFolderId,
        that,
        'uploadFileAdd',
        null,
        'uploadFileProgress',
        'uploadFileDone',
        deleteOnEnd,
      );
    },

    // attached file upload options
    createAttachedFileUploadOptions: function createAttachedFileUploadOptions(deleteOnEnd) {
      return BulbAssetLibraryUploadService.createAttachedFileUploadOptions(
        () => that.currentFolderId,
        that,
        'uploadFileAdd',
        null,
        'uploadFileProgress',
        'uploadFileDone',
        deleteOnEnd,
      );
    },

    // audio upload options
    createAudioUploadOptions: function createAudioUploadOptions(deleteOnEnd) {
      return BulbAssetLibraryUploadService.createAudioUploadOptions(
        () => that.currentFolderId,
        that,
        'uploadFileAdd',
        null,
        'uploadFileProgress',
        'uploadFileDone',
        deleteOnEnd,
      );
    },

  };

  this.isModalExists = function isModalExists() {
    return $modalStack.getTop();
  };

  const isUploadable = function isUploadable() {
    return !that.isModalExists() && !BulbAssetLibraryGoogleDriveService.pickerVisibility;
  };

  const authenticateFileType = function authenticateFileType(intendedType, file) {
    switch (intendedType) {
      case 'image':
        return !!BulbAssetLibraryUploadService.checkImageFileName(file.name);
      case 'video':
        return !!BulbAssetLibraryUploadService.checkVideoFileName(file.name);
      case 'audio':
        return !!BulbAssetLibraryUploadService.checkAudioFileName(file.name);
      case 'attachedFile':
        return !(BulbAssetLibraryUploadService.checkImageFileName(file.name)
              || BulbAssetLibraryUploadService.checkVideoFileName(file.name)
              || BulbAssetLibraryUploadService.checkAudioFileName(file.name));
    }
  };

  // drag and drop uploaders
  if (!this.readOnly) {
    /**
     * FUTURE CLEAN : Not happy with this 'implementation' of the drag and drop with our new upload workflow however
     * due to the current timeline and the push to get this out, it will have to do.
     *
     * Ideally, I would absolutely love to use Uppy's Drag & Drop plugin. I would have to come back and
     * implement that later.
     * ^^ https://bulbapp.atlassian.net/browse/BULBAPP-1273
     */
    const $fileDragAndDropUploader = $(BulbAssetLibraryUploadService.createInputFileElement(true));
    {
      $fileDragAndDropUploader.attr('accept', ASSET_LIBRARY.FILTER.IMAGE);
      const uploadOptions = angular.merge({}, that.uploadOptions.createImageUploadOptions(false));
      uploadOptions.add = function uploadOptionsAdd(e, data) {
        if (!isUploadable() || !authenticateFileType('image', data.files[0])) {
          return;
        }
        // ***IMPORTANT*** this needed for now to skip our old special callback add functionality.
        // Since we are using the new upload workflow, for everything.
        // eslint-disable-next-line no-param-reassign
        data.abortUploading = true;

        that.uploadOptions.createImageUploadOptions().add(e, data);
      };
      $fileDragAndDropUploader.fileupload(uploadOptions);
    }

    // Bind functionality on drop area from within the assetlibrary:
    $('#bulb-asset-library-drop-area').bind('drop', (event) => {
      // Prevent default behavior (Prevent file from being opened)
      event.preventDefault();
      if (event.originalEvent.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        // Should really only be one file for us now, since we don't allow / support multi-file upload, yet.
        for (let i = 0; i < event.originalEvent.dataTransfer.items.length; i += 1) {
          // If dropped items aren't files, reject them
          if (event.originalEvent.dataTransfer.items[i].kind === 'file') {
            const file = event.originalEvent.dataTransfer.items[i].getAsFile();
            let attr = '*';
            if (file.type.includes('image')) {
              attr = ASSET_LIBRARY.FILTER.IMAGE;
            } else if (file.type.includes('audio')) {
              attr = ASSET_LIBRARY.FILTER.AUDIO;
            } else if (file.type.includes('video')) {
              attr = ASSET_LIBRARY.FILTER.VIDEO;
            }
            const initDragAndDropEvent = new CustomEvent('initDragAndDrop', {
              detail: {
                file,
                attr,
                fromWithinAssetLibrary: true,
                uploadState: 'draganddrop',
              },
            });
            $window.dispatchEvent(initDragAndDropEvent);
          }
        }
      }
    });

    $scope.$on('$destroy', () => {
      $fileDragAndDropUploader.remove();
    });
  }

  // drop area
  $timeout(() => {
    if (that.readOnly) {
      const showUploadTabDragArea = function showUploadTabDragArea() {
        $('#assetlibrary-file-drop-area-cover').show();
      };

      const hideUploadTabDragArea = function hideUploadTabDragArea() {
        $('#assetlibrary-file-drop-area-cover').hide();
      };

      // To avoid the duplicate id while fast pass the id's for the attached-file <div> is different and rest
      // is different so adding this if check to identify the same.
      if (that.condition.typeFilter.ATTACHED_FILE) {
        $('#assetlibrary-file-drop-area').on('dragover', showUploadTabDragArea);
      } else {
        $('#assetlibrary-file-drop-area-second').on('dragover', showUploadTabDragArea);
      }
      $body.on('mouseup', hideUploadTabDragArea);
      $('#assetlibrary-file-drop-area-cover').on('dragleave', hideUploadTabDragArea);

      if (that.condition.typeFilter.ATTACHED_FILE) {
        $('#assetlibrary-file-drop-area').on('drop', hideUploadTabDragArea);
      } else {
        $('#assetlibrary-file-drop-area-second').on('drop', hideUploadTabDragArea);
      }
    } else {
      const showDragArea = function showDragArea() {
        if (isUploadable()) {
          $('#bulb-asset-library-drop-area').show();
        }
      };

      const hideDragArea = function hideDragArea() {
        $('#bulb-asset-library-drop-area').hide();
      };

      $body.on('dragover', showDragArea);
      $body.on('mouseup', hideDragArea);
      const $dropArea = $('#bulb-asset-library-drop-area-inner');
      $dropArea.on('dragleave', hideDragArea);
      $dropArea.on('drop', hideDragArea);
    }
  }, 200);

  // upload video
  this.uploadVideo = function uploadVideo() {
    BulbAssetLibraryService.dialog.dismissAllModals();
    BulbAssetLibraryUploadService.uploadFile(
      this.uploadOptions.createVideoUploadOptions(true),
      ASSET_LIBRARY.FILTER.VIDEO,
      true,
      true,
      'assetlibrary',
    );
  };

  // upload audio
  this.uploadAudio = function uploadAudio() {
    BulbAssetLibraryService.dialog.dismissAllModals();
    BulbAssetLibraryUploadService.uploadFile(
      this.uploadOptions.createAudioUploadOptions(true),
      ASSET_LIBRARY.FILTER.AUDIO,
      true,
      'assetlibrary',
    );
  };

  this.uploadFileAdd = function uploadFileAdd(/* e, data */) {
    that.getEntriesAndUpdateList();
    BulbAssetLibraryService.dialog.dismissAllModals();
  };

  this.uploadFileDone = function uploadFileDone(e, data) {
    that.updateUploadProgressBar(data.entry.id, 100);
    that.getEntriesAndUpdateList();
  };

  /**
   * Callback for updating the progress of file uploads.
   * https://github.com/blueimp/jQuery-File-Upload/wiki/Options#progress
   */
  this.uploadFileProgress = function uploadFileProgress(e, data, progress) {
    that.updateUploadProgressBar(data.entry.id, progress);
  };

  this.updateUploadProgressBar = function updateUploadProgressBar(id, progress) {
    for (let i = 0; i < that.entries.length; i += 1) {
      const e = that.entries[i];
      if (e && e.id === id) {
        e.progress = progress;
        break;
      }
    }

    // update targetEntry
    if (that.targetEntry && that.targetEntry.id === id) {
      that.targetEntry.progress = progress;
    }
  };

  this.isListHeaderVisible = function isListHeaderVisible() {
    /* jshint camelcase: false */
    return !BulbBlockViewSwitcherService.isTile(this.infoType) && Foundation.utils.is_medium_up();
  };

  this.isEmptyImageVisible = function isEmptyImageVisible() {
    /* jshint camelcase: false */
    return this.entries !== null && this.entries.length === 0 && !this.readOnly
        && Foundation.utils.is_large_up() && !this.searchEnabled;
  };

  this.isEntriesScrollable = function isEntriesScrollable() {
    /* jshint camelcase: false */
    return this.readOnly && Foundation.utils.is_medium_up();
  };

  this.isUsageScrollable = function isUsageScrollable() {
    /* jshint camelcase: false */
    return Foundation.utils.is_medium_up();
  };

  /**
   * Handle the upload finish call from the Uppy Dashboard.
   */
  this.handleOnCompleteUppyUpload = function handleOnCompleteUppyUpload() {
    // update storage info
    BulbAuthService.fetchCurrentUser().then(() => {
      that.getEntriesAndUpdateList();
    });
  };

  /**
   * This is for listening to the unsplash upload event being finished.
   */
  AssetUploadEventService.uppyEventEmitter.subscribe((event) => {
    if (event.status === 'PROCESSING_SUCCESS') {
      this.handleOnCompleteUppyUpload();
    }
  });
}
